module.exports = __webpack_public_path__ + "img/t4-endorsement-statement.e9e679d4.png";